import { gql } from '@apollo/client';

export const GET_ME = gql`
  query {
    me {
      chatUser {
        token
        userId
        userNickName
      }
      user {
        id
        email
        mobileNumber
        nickname
        birth
        gender
        verified
        noticeReceiveAgreements {
          id
          channel
          advertised
          agreed
          agreedAt
          updatedAt
        }
        socialLinks {
          id
          socialUserId
          provider
        }
        privateProfile
        joinedAt
        certificated
        invitationCode
        profileImage {
          type
          width
          height
          uri
          thumbnail(
            width: 64
            aspectRatio: "1:1"
            crop: FILL
            fetchFormat: WEBP
          )
        }
        usablePoint {
          availables
        }
      }
      host {
        id
        name
        createdAt
        description
        phoneNumber
        super
        personalInfo {
          email
          name
          phoneNumber
          notificationPhoneNumber
        }
        wishInfo {
          count
          isWishedByMe
        }
        productReviewInfo {
          count
        }
        productInfo {
          counts {
            count
            status
          }
        }
        profileImage {
          thumbnail(width: 48, aspectRatio: "1:1", crop: FILL)
        }
        settlement {
          attachments(statusIn: [ACTIVE]) {
            createdAt
            fileKey
            id
          }
          businessInfo {
            businessItem
            businessType
            address
            status
            representativeName
            taxPayerName
            taxPayerType
            isRegister
          }
          bankAccount {
            account {
              accountNo
              bank {
                code
                name
              }
              holder
            }
            verified
            verifiedAt
          }
          tossSellerInfo {
            businessType
            createdAt
            hostId
            isActive
            refSellerId
            registrationNo
            status
            tossSellerId
            updatedAt
          }
        }
        commission {
          absent {
            bias
            charge
            type
          }
        }
      }
      issuedCoupons(filter: { used: false }, page: 1, size: 1) {
        totalCount
      }
    }
  }
`;
